// extracted by mini-css-extract-plugin
export default {"root":"Box_root__VBs5m","color-default":"Box_color-default__or1S5","color-primary":"Box_color-primary__tbpng"};